<script lang="ts">
	import { Icons } from '$lib/components/icon'
	import { Icon } from '@repo/ui'

	interface Props {
		text: string
	}

	let { text }: Props = $props()
</script>

<p class="mt-2 flex items-center space-x-1 text-base text-yellow-800 dark:text-yellow-200">
	<Icon class="text-yellow-500 dark:text-yellow-300" small src={Icons.ExclamationTriangle} />
	<span class="text-xs">{text}</span>
</p>
